import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

import { DATEFORMAT_MDY } from 'utils/constants/common';

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(relativeTime);

/**
 * Convert Date with custom format
 * @param date
 * @param format
 */
export const convertDate = (date: string | any, format: string) => {
    if (date && format) {
        return dayjs.utc(date).local().format(format);
    }
    return null;
};

/**
 * Get Date From Various Day, Week, Month
 * @param type
 */
export const getDateFromVarious = (type: string) => {
    if (type === 'DAY') {
        return dayjs()
            .utc()
            .local()
            .add(dayjs.duration({ days: 1 }))
            .format('YYYY-MM-DD');
    }
    if (type === 'WEEK') {
        return dayjs()
            .utc()
            .local()
            .add(dayjs.duration({ weeks: 1 }))
            .format('YYYY-MM-DD');
    }
    if (type === 'MONTH') {
        return dayjs()
            .utc()
            .local()
            .add(dayjs.duration({ months: 1 }))
            .format('YYYY-MM-DD');
    }
};

/**
 * Date Ago
 * @param date
 * @param withSuffix
 */
export const dateFromNow = (date: string | null, withSuffix: boolean) => {
    if (date) {
        const utcFormat = dayjs.utc(date).local();
        if (withSuffix) {
            return dayjs(utcFormat).fromNow(true);
        }
        return dayjs(utcFormat).fromNow();
    }
    return null;
};

/**
 * Poll End Date
 * @param date
 * @param withSuffix
 */
export const pollEndDate = (date: string | null, withSuffix: boolean) => {
    if (date) {
        const utcFormat = dayjs.utc(date).local();
        if (withSuffix) {
            return dayjs(new Date()).to(utcFormat, true);
            // return dayjs(utcFormat).fromNow(true);
        }
        return dayjs(utcFormat).fromNow();
    }
    return null;
};

/**
 * Hour convert to min
 * @param time
 * @returns
 */
export const convertDuration = (time: string) => {
    if (!time) {
        return null;
    }
    const timeParts = time.split(':');
    const mins = parseInt(timeParts[0]);
    const sec = timeParts[1];
    let playerDuration = '';
    if (mins > 59 && mins !== 0) {
        const hours = Math.floor(mins / 60);
        const minutes = mins % 60;
        playerDuration = `${hours} hours ${minutes !== 0 ? `${minutes} mins` : ''} `;
    } else if (mins < 59 && mins !== 0) {
        playerDuration = `${mins} mins`;
    } else {
        playerDuration = `${sec} sec`;
    }
    return playerDuration;
};

export const toDateFn = (date?: Date | null | string) => {
    try {
        return date ? new Date(date) : new Date();
    } catch (error) {
        return null;
    }
};

export const getDateFormat = (dateFormat?: Date | null | string) => {
    return convertDate(dateFormat, DATEFORMAT_MDY);
};
